<template>
  <div class="creditDuration">
    <div class="rule-form">
      <el-form ref="creditDurationRuleForm" :model="creditDurationRuleForm" hide-required-asterisk label-width="100px">
        <div class="deduction-rule-box">
          <el-form-item label="抵扣规则" prop="limitType">
             <el-radio-group v-model="creditDurationRuleForm.limitType"  v-if="!edit">
                <el-radio label="Time">按时间抵扣(一天)</el-radio>
                <el-radio label="Bill">按账单抵扣</el-radio>
              </el-radio-group>
            <span v-if="edit" class="input-remark">{{creditDurationRuleForm.limitType!='Bill'?'按时间抵扣(一天)':'按账单抵扣'}}</span>
          </el-form-item>
        </div>
       <el-form-item label="每次抵扣上限">
          <div class="hint-remark" v-if="creditDurationRuleForm.limitType!='Bill'">
            <div class="text">（以下为各会员等级的当天抵扣上限时间或金额）</div>
          </div>
          <div class="hint-remark" v-else>
            <div class="text">（以下为各会员等级的账单抵扣上限时间或金额）</div>
          </div>
        </el-form-item>
        <div v-for="(item,index) in creditDurationRuleForm.levelDiscountList" :key="index">
          <el-form-item :label="item.levelName+'可免'" >
            <div v-if="!edit">
             <el-input class="input" v-model="item.freeTime" v-if="item.mode!='FreeMoney'" placeholder="请输入大于0的数值"  oninput="value=value.replace(/[^.\d]/g,'')">
              <template slot="prepend">
                <el-select v-model="item.mode">
                 <el-option label="抵扣时间" value="FreeTime"></el-option>
                 <el-option label="抵扣金额" value="FreeMoney"></el-option>
                </el-select>
              </template>
              <template slot="append" v-if="item.mode!='FreeMoney'">
                <el-select v-model="item.unit">
                 <el-option label="分钟" value="Minute"></el-option>
                 <el-option label="小时" value="Hour"></el-option>
                </el-select>
              </template>
               <template slot="append" v-else>元</template>
            </el-input>
            <el-input  v-else  class="input" v-model="item.freeMoney" placeholder="请输入大于0的数值" oninput="value=value.replace(/[^.\d]/g,'')">
              <template slot="prepend">
                <el-select v-model="item.mode">
                 <el-option label="抵扣时间" value="FreeTime"></el-option>
                 <el-option label="抵扣金额" value="FreeMoney"></el-option>
                </el-select>
              </template>
              <template slot="append" v-if="item.mode!='FreeMoney'">
                <el-select v-model="item.unit">
                 <el-option label="分钟" value="Minute"></el-option>
                 <el-option label="小时" value="Hour"></el-option>
                </el-select>
              </template>
               <template slot="append" v-else>元</template>
            </el-input>
            </div>
            <span v-if="edit&&item.mode!='FreeMoney'" class="input-remark">{{detailContent(item.mode,item.unit,item.freeTime)}}</span>
            <span v-else-if="edit&&item.mode!='FreeTime'" class="input-remark">{{detailContent(item.mode,item.unit,item.freeMoney)}}</span>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="footer">
       <el-button v-if="!edit"  @click="onBack"  class="fun-btn mr20">取消</el-button>
       <auth-button auth="parking:member:discount:edit">
        <el-button v-if="edit" :loading="submitLoading" type="primary" @click="()=>{edit=false}" class="fun-btn">编辑</el-button>
      </auth-button>
      <el-button v-if="!edit" :loading="submitLoading" type="primary" @click="onSubimt" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>
<script>
import AuthButton from '@/components/AuthButton'
import {api_getParkingMemberDiscount,api_postParkingMemberDiscount} from '@/api/parking'
export default {
  name: "creditDuration",
  components: {
    AuthButton
  },
  props: {
    mallId: {
      type: String,
    },
  },
  data() {
    return {
      creditDurationRuleForm:{},
      mallIds:'',
      edit:true,
      freeTime:'',
      freeMoney:'',
      submitLoading: false,
    };
  },
  created() {
    
  },
  mounted(){
    this.mallIds = this.mallId
    this.getMemberDiscount()
  },
  methods: {
    async getMemberDiscount(){
        let params = {
          mallId:this.mallIds
        }
        let res = await api_getParkingMemberDiscount(params)
        res = JSON.parse(JSON.stringify(res)) 
        let arr = res.levelDiscountList.map((item)=>{
          return {
            ...item,
            mode:item.mode?item.mode:'FreeTime',
            unit:item.unit?item.unit:'Hour',
            freeTime:item.freeTime?item.freeTime:'',
            freeMoney:item.freeMoney?item.freeMoney:'',
          }
        })
        this.creditDurationRuleForm = {
          ...res,
          mallId:this.mallIds,
          limitType:res.limitType?res.limitType:'Time',
          levelDiscountList:arr,
        }
        
    },
    detailContent(mode,unit,value){
      if(value&&mode=='FreeTime'){
        return `${value}${unit=='Hour'?'小时':'分钟'}`
      }else if(value&&mode=='FreeMoney'){
        return `${value}元`
      }
      return '---'
    },
    async onSubimt(){
        this.$refs.creditDurationRuleForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = JSON.parse(JSON.stringify(this.creditDurationRuleForm))
          let paramsArr  = []
          params.levelDiscountList.forEach(item => {
            if( item.mode == 'FreeTime' && item.freeTime != ''){
               paramsArr.push(item)
            }
            if( item.mode == 'FreeMoney' && item.freeMoney != ''){
              paramsArr.push(item)
            }
          });
          params.levelDiscountList = paramsArr
          params.levelDiscountList.map(item=>{
            if(item.mode == 'FreeTime'){
              delete item.freeMoney
            }
             if(item.mode == 'FreeMoney'){
              delete item.freeTime
              delete item.unit
            }
            return item
          })
          try {
          await api_postParkingMemberDiscount(params)
          this.$baseMessage('保存成功', 'success')
          this.onBack()
          this.submitLoading = false
          }
          catch(error){
          this.submitLoading = false
          }
          }else {
          return false
        }
      })
    },
    // 取消
    onBack() {
      this.getMemberDiscount()
      this.edit = true
    },
  },
  watch: {
      mallId: {
        immediate: true,
        handler(value,old) {
          this.mallIds = value
          this.getMemberDiscount()
        }
      }
    },
};
</script>

<style lang="scss" scoped>
.creditDuration {
  width: 100%;
  margin-top:35px;
  padding: 35px 20px;
  padding-top: 0;
  padding-bottom: 74px;
  box-sizing: border-box;
  .divider1 {
    margin: 0;
    margin-top: 28px;
  }
  .divider2 {
    margin: 0;
  }
  .el-input,
  .el-textarea,
  .el-select {
    width: 120px;
  }
  .title {
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 25px;

    .btn.el-button {
      color: #1A5CF5;
      margin-left: 10px;
    }
  }

  .rule-form {
    margin-top: 20px;
    .el-textarea{
      width: 350px;
    }
    .el-input {
      width: 500px !important;
    }

    .input-remark {
      font-size: 14px;
      color: #333333;
      margin-left: 10px;
    }

    .hint-remark {
      font-size: 12px;
      display: inline-block;
      position: relative;
      width: 400px;
      height: 34px;
      color: #666666;
      .text {
        height: 17px;
        line-height: 17px;
        position: absolute;
        left: 0;
        bottom: 8px;
      }
    }

    .deduction-rule-box {
      display: flex;
    }
  }

  .shop-rule-box {
    margin-top: 20px;

    .fun-btn-box {
      margin: 20px 0;
    }
  }

  .add-rule-dialog {
    padding-top: 20px;
    position: relative;
    .dialog-footer {
      text-align: right;
    }
    ::v-deep{
      .el-select{
        width: 100%;
      }
      .el-form-item{
        &.notes {
          margin-bottom: 32px;
          .el-form-item__content {
            &::before {
              position: absolute;
              left: 0;
              bottom: -22px;
              content: '( 填写“0”表示永久有效 )';
              width: 140px;
              height: 17px;
              line-height: 17px;
              font-size: 12px;
              color: #666666;
            }
            .el-form-item__error {
              height: 17px;
              left: 140px;
              padding-top: 7px;
            }
          }
        }
      }
    }
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .true{
    background: #F74A4A;
  }
  .false{
    background: #05c8af;
  }
  .picUrl{
    width: 150px;
    height: 150px;
    display: inline-block;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
  .lookTextArea{
    width: 400px;
    height: 200px;
    background: #F2F3F5;
    border-radius: 2px;
    overflow: auto;
    padding: 20px;
    box-sizing: border-box;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
  }
  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
